interface IProps {
  isScroll: boolean;
}
export const Divider = ({ isScroll }: IProps) => {
  return (
    <div
      style={{
        height: "150px",
        display: isScroll ? "block" : "none",
      }}
    ></div>
  );
};
